import Vue from 'vue'
import { Toast, Dialog } from 'vant';

Vue.prototype.toast = function ({icon = '', text}) {
    /*
    * icon:
    *       success
    *       warning
    *       close
    * */
    Toast({
        message: text,
        icon
    });
};

Vue.prototype.loading = function ({text = '加载中...'}) {
    Toast.loading({
        message: text,
        forbidClick: true
    });
};

Vue.prototype.clearToast = function () {
    Toast.clear();
};

Vue.prototype.alert = function ({title = '提示', text, fn = _ => {}, confirmButtonText = '确定'}) {
    Dialog.alert({
        title,
        message: text,
        confirmButtonText
    }).then(() => {
        // on close
        fn();
    });
};

Vue.prototype.confirm = function ({title = '提示', text, thenFn = _ => {}, catchFn = _ => {}, confirmButtonText = '确定', cancelButtonText = '取消'}) {
    Dialog.confirm({
        title,
        message: text,
        confirmButtonText,
        cancelButtonText
    }).then(() => {
        // on confirm
        thenFn()
    }).catch(() => {
        // on cancel
        catchFn();
    });
};

// 跳转页面
Vue.prototype.toPage = function (path, isReplace) {
    this.$router[isReplace ? 'replace' : 'push'](path);
};

// 跳转页面
Vue.prototype.goBack = function (back = -1) {
    this.$router.go(back);
};

Vue.prototype.getTimes = function (time, format = 'YYYY-MM-DD HH:mm:ss') {
    return this.$moment(time).format(format)
};

Vue.prototype.getMonthRange = function(yearMonth, isSeconds = false) {
    if (!yearMonth || !/^\d{4}-\d{2}$/.test(yearMonth)) {
        return null;
    }
    
    const start = this.$moment(yearMonth, 'YYYY-MM').startOf('month');
    const end = this.$moment(yearMonth, 'YYYY-MM').endOf('month');
    
    return {
        start: isSeconds ? start.unix() : start.valueOf(),
        end: isSeconds ? end.unix() : end.valueOf(),
        startDate: start.format('YYYY-MM-DD HH:mm:ss'),
        endDate: end.format('YYYY-MM-DD HH:mm:ss')
    };
};



// WEBPACK FOOTER //
// ./src/utils/tools.js